// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3KoUT","detailsBorder":"styles_detailsBorder__1EH4B"};